module.exports = __webpack_public_path__ + "static/img/xd.81356b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/xd.jpg
// module id = dVdj
// module chunks = 59